/* eslint-disable no-unused-vars */
import { HitDecisions } from "../profiles/types/amlScreen.type";
export enum AmlCategory {
  sanctions = "sanctions",
  enforcement = "enforcement",
  insolvencyRegister = "insolvencyRegister",
  stateOwnedEnterprise = "stateOwnedEnterprise",
  pep = "pep",
  pepLinked = "pepLinked",
  profileOfInterest = "profileOfInterest",
  adverseMedia = "adverseMedia",
  disqualifiedDirector = "disqualifiedDirector",
  stateOwnedEnterpriseCurrent = "stateOwnedEnterpriseCurrent",
  stateOwnedEnterpriseFormer = "stateOwnedEnterpriseFormer",
  sanctionsCurrent = "sanctionsCurrent",
  sanctionsFormer = "sanctionsFormer",
  pepCurrent = "pepCurrent",
  pepFormer = "pepFormer",
}

export const keyPartiesAMlModalCategories = [
  AmlCategory.sanctions,
  AmlCategory.enforcement,
  AmlCategory.insolvencyRegister,
  AmlCategory.stateOwnedEnterprise,
  AmlCategory.disqualifiedDirector,
  AmlCategory.pep,
  AmlCategory.profileOfInterest,
  AmlCategory.adverseMedia,
];

export const businessCategories = [
  AmlCategory.sanctions,
  AmlCategory.sanctionsCurrent,
  AmlCategory.sanctionsFormer,
  AmlCategory.enforcement,
  AmlCategory.insolvencyRegister,
  AmlCategory.stateOwnedEnterprise,
  AmlCategory.stateOwnedEnterpriseCurrent,
  AmlCategory.stateOwnedEnterpriseFormer,
  AmlCategory.pep,
  AmlCategory.pepLinked,
  AmlCategory.profileOfInterest,
  AmlCategory.adverseMedia,
];

export const individualCategories = [
  AmlCategory.sanctions,
  AmlCategory.sanctionsCurrent,
  AmlCategory.sanctionsFormer,
  AmlCategory.enforcement,
  AmlCategory.insolvencyRegister,
  AmlCategory.disqualifiedDirector,
  AmlCategory.pep,
  AmlCategory.pepCurrent,
  AmlCategory.pepFormer,
  AmlCategory.pepLinked,
  AmlCategory.profileOfInterest,
  AmlCategory.adverseMedia,
];

export const businessCategoriesSanctionEnabled = [
  AmlCategory.sanctionsCurrent,
  AmlCategory.sanctionsFormer,
  AmlCategory.enforcement,
  AmlCategory.insolvencyRegister,
  AmlCategory.stateOwnedEnterpriseCurrent,
  AmlCategory.stateOwnedEnterpriseFormer,
  AmlCategory.pepLinked,
  AmlCategory.profileOfInterest,
  AmlCategory.adverseMedia,
];

export const individualCategoriesSanctionEnabled = [
  AmlCategory.sanctionsCurrent,
  AmlCategory.sanctionsFormer,
  AmlCategory.enforcement,
  AmlCategory.insolvencyRegister,
  AmlCategory.disqualifiedDirector,
  AmlCategory.pepCurrent,
  AmlCategory.pepFormer,
  AmlCategory.pepLinked,
  AmlCategory.profileOfInterest,
  AmlCategory.adverseMedia,
];

export const pepTiers = ["pepTier1", "pepTier2", "pepTier3"];

export const apiParameterBusinessMappings: { [key: string]: string } = {
  sanctions: "SAN",
  sanctionscurrent: "SAN-CURRENT",
  sanctionsformer: "SAN-FORMER",
  sanctionspeplinked: "SAN",
  sanctionscurrentformer: "SAN-CURRENT,SAN-FORMER",
  sanctionscurrentformerpeplinked: "SAN-CURRENT,SAN-FORMER",
  enforcement: "ENF",
  insolvencyregister: "INS",
  stateownedenterprise: "SOE",
  stateownedenterprisecurrent: "SOE-CURRENT",
  stateownedenterpriseformer: "SOE-FORMER",
  stateownedenterprisecurrentformer: "SOE-CURRENT,SOE-FORMER",
  pep: "PEP",
  pepcurrent: "PEP",
  pepformer: "PEP",
  peplinked: "PEP-LINKED",
  pepcurrentformerpeplinked: "PEP-LINKED",
  pepcurrentformer: "PEP",
  profileofinterest: "POI",
  adversemedia: "AM",
  sanctionscurrentpeplinked: "SAN-CURRENT,PEP-LINKED",
  sanctionsformerpeplinked: "SAN-FORMER,PEP-LINKED",
};

export const apiParameterIndividualMappings: { [key: string]: string } = {
  sanctions: "SAN",
  sanctionscurrent: "SAN-CURRENT",
  sanctionsformer: "SAN-FORMER",
  sanctionscurrentformer: "SAN-CURRENT,SAN-FORMER",
  sanctionscurrentformerpeplinked: "SAN-CURRENT,SAN-FORMER",
  sanctionscurrentpeplinked: "SAN-CURRENT",
  sanctionspeplinked: "SAN,PEP-LINKED",
  enforcement: "ENF",
  insolvencyregister: "INS",
  disqualifieddirector: "DD",
  pep: "PEP",
  pepcurrent: "PEP-CURRENT",
  pepformer: "PEP-FORMER",
  pepcurrentformer: "PEP-CURRENT,PEP-FORMER",
  peplinked: "PEP-LINKED",
  peplinkedcurrent: "PEP-LINKED,PEP-CURRENT",
  peplinkedformer: "PEP-LINKED,PEP-FORMER",
  peplinkedcurrentformer: "PEP-LINKED,PEP-CURRENT,PEP-FORMER",
  pepcurrentformerpeplinked: "PEP-LINKED,PEP-CURRENT,PEP-FORMER",
  peplinkedcurrentpeplinked: "PEP-LINKED,PEP-CURRENT",
  pepcurrentpeplinked: "PEP-LINKED,PEP-CURRENT",
  pepformerpeplinked: "PEP-LINKED,PEP-FORMER",
  peppeplinked: "PEP-LINKED",
  profileofinterest: "POI",
  adversemedia: "AM",
};

export const searchTypes = {
  business: "business",
  individual: "individual",
};

export const searchApiTypes = {
  business: "businesses",
  individual: "individuals",
};

export const headingsBusiness = [
  "amlSearchResultHeaders.name",
  "amlSearchResultHeaders.countryLocations",
  "amlSearchResultHeaders.category",
  "amlSearchResultHeaders.matchPercent",
];

export const headingsIndividual = [
  "amlSearchResultHeaders.name",
  "",
  "amlSearchResultHeaders.countryLocations",
  "amlSearchResultHeaders.dob",
  "amlSearchResultHeaders.gender",
  "amlSearchResultHeaders.category",
  "amlSearchResultHeaders.pepTier",
  "amlSearchResultHeaders.matchPercent",
];

export const amlCategoryTypes = {
  ENF: "Enforcement",
  SAN: "Sanctions",
  "SAN-CURRENT": "Sanctions- Current",
  "SAN-FORMER": "Sanctions- Former",
  INS: "Insolvency Register",
  DD: "Disqualified Director",
  POI: "POI",
  AM: "Adverse Media",
  PEP: "PEP",
  "PEP-CURRENT": "PEP- Current",
  "PEP-FORMER": "PEP- Former",
  "PEP-LINKED": "PEP- Linked",
  SOE: "SOE",
  "SOE-CURRENT": "SOE- Current",
  "SOE-FORMER": "SOE- Former",
};

export const amlHitsCategoryTypes = {
  ENF: "Enforcement",
  SAN: "Sanctions",
  "SAN-CURRENT": "Sanctions - Current",
  "SAN-FORMER": "Sanctions - Former",
  INS: "Insolvency Register",
  DD: "Disqualified Director",
  POI: "Profile of Interest",
  AM: "Adverse Media",
  PEP: "PEP",
  "PEP-CURRENT": "PEP - Current",
  "PEP-FORMER": "PEP - Former",
  "PEP-LINKED": "PEP - Linked",
  SOE: "State Owned Enterprise",
  "SOE-CURRENT": "State Owned Enterprise - Current",
  "SOE-FORMER": "State Owned Enterprise - Former",
};

export const amlHitsCategoryTypesWithSanctions = {
  ENF: "Enforcement",
  "SAN-CURRENT": "Sanctions - Current",
  "SAN-FORMER": "Sanctions - Former",
  INS: "Insolvency Register",
  DD: "Disqualified Director",
  POI: "Profile of Interest",
  AM: "Adverse Media",
  PEP: "PEP",
  "PEP-CURRENT": "PEP - Current",
  "PEP-FORMER": "PEP - Former",
  "PEP-LINKED": "PEP - Linked",
  "SOE-CURRENT": "State Owned Enterprise - Current",
  "SOE-FORMER": "State Owned Enterprise - Former",
};

export const pepTierValues = {
  tier1: "PEP Tier 1",
  tier2: "PEP Tier 2",
  tier3: "PEP Tier 3",
};

export const addSearchToValues = {
  individual: "INDIVIDUAL",
  business: "BUSINESS",
  keyParties: "KEY PARTIES",
  ubos: "UBOs",
};

export const businessProfiles = [
  "trust",
  "company",
  "partnership",
  "otherEntity",
  "plc",
];

export const business = "business";
export const individual = "individual";
export const maxRecordsAllowed = 15;
export const amlOptions = {
  addNew: "addNew",
  amlScreen: "amlScreen",
};

export const kycAlertsStatus = {
  closedProcessed: "closedProcessed",
};

export const mappingValuesForMonitoring = {
  san: "SAN",
  current: "current",
  former: "former",
  pep: "PEP",
  soe: "SOE",
  pepLinked: "pepLinked",
  soeFormer: "SOE-FORMER",
  soeCurrent: "SOE-CURRENT",
  PEPlinked: "PEP-LINKED",
  dd: "DD",
};

export const amlCheckIndividualCategories = [
  "sanctionsCurrent",
  "sanctionsFormer",
  "enforcement",
  "pepCurrent",
  "pepFormer",
  "pepLinked",
  "insolvencyRegister",
  "adverseMedia",
  "disqualifiedDirector",
  "profileOfInterest",
];

export const amlCheckBusinessCategories = [
  "sanctionsCurrent",
  "sanctionsFormer",
  "enforcement",
  "stateOwnedEnterpriseCurrent",
  "stateOwnedEnterpriseFormer",
  "pepLinked",
  "insolvencyRegister",
  "adverseMedia",
  "profileOfInterest",
];

export const allHitDecisions = [
  HitDecisions.undecided,
  HitDecisions.trueMatch,
  HitDecisions.discarded,
  HitDecisions.falsePositive,
];

export const apiAMLScreenParameterBusinessMappings: { [key: string]: string } =
  {
    sanctions: "SAN",
    sanctionsCurrent: "SAN-CURRENT",
    sanctionsFormer: "SAN-FORMER",
    sanctionsLinked: "SAN",
    enforcement: "ENF",
    insolvencyRegister: "INS",
    stateOwnedEnterprise: "SOE",
    stateOwnedEnterpriseCurrent: "SOE-CURRENT",
    stateOwnedEnterpriseFormer: "SOE-FORMER",
    pep: "PEP",
    pepCurrent: "PEP-CURRENT",
    pepFormer: "PEP-FORMER",
    pepLinked: "PEP-LINKED",
    pepCurrentFormer: "PEP",
    profileOfInterest: "POI",
    adverseMedia: "AM",
  };

export const apiAMLScreenParameterIndividualMappings: {
  [key: string]: string;
} = {
  sanctions: "SAN",
  sanctionsCurrent: "SAN-CURRENT",
  sanctionsFormer: "SAN-FORMER",
  enforcement: "ENF",
  insolvencyRegister: "INS",
  disqualifiedDirector: "DD",
  pep: "PEP",
  pepCurrent: "PEP-CURRENT",
  pepFormer: "PEP-FORMER",
  pepLinked: "PEP-LINKED",
  profileOfInterest: "POI",
  adverseMedia: "AM",
  stateOwnedEnterprise: "SOE",
};
export const NAVIGATE_BACK = -1;
export const MIN_YEAR = 1900;
export const AML_DETAILS_ID_INDEX = 2;
export const RETRY_DELAY = 3000;
export const RETRY_ATTEMPTS = 3;
export const TEST_RETRY_DELAY = 100;
export const DEFAULT_ERROR_STATUS = 500;
export const MAX_ALLOWED_EMAILS = 5;
export const MAX_PROFILE_LENGTH = 150;

const HTTP_UNAUTHORIZED = 401;
const HTTP_NOT_FOUND = 404;
const HTTP_METHOD_NOT_ALLOWED = 405;
const HTTP_PROXY_AUTH_REQUIRED = 407;
const HTTP_REQUEST_TIMEOUT = 408;
const HTTP_URI_TOO_LONG = 414;
const HTTP_UNSUPPORTED_MEDIA_TYPE = 415;
const HTTP_EXPECTATION_FAILED = 417;
const HTTP_MISDIRECTED_REQUEST = 421;
const HTTP_UNPROCESSABLE_ENTITY = 422;
const HTTP_INTERNAL_SERVER_ERROR = 500;
const HTTP_NOT_IMPLEMENTED = 501;
const HTTP_BAD_GATEWAY = 502;
const HTTP_SERVICE_UNAVAILABLE = 503;
const HTTP_GATEWAY_TIMEOUT = 504;
const HTTP_VERSION_NOT_SUPPORTED = 505;
const HTTP_VARIANT_ALSO_NEGOTIATES = 506;
const HTTP_NOT_EXTENDED = 510;
const HTTP_NETWORK_AUTH_REQUIRED = 511;

export const RETRY_STATUS_CODES = new Set([
  HTTP_NETWORK_AUTH_REQUIRED,
  HTTP_NOT_EXTENDED,
  HTTP_VARIANT_ALSO_NEGOTIATES,
  HTTP_VERSION_NOT_SUPPORTED,
  HTTP_GATEWAY_TIMEOUT,
  HTTP_SERVICE_UNAVAILABLE,
  HTTP_BAD_GATEWAY,
  HTTP_NOT_IMPLEMENTED,
  HTTP_INTERNAL_SERVER_ERROR,
  HTTP_UNPROCESSABLE_ENTITY,
  HTTP_MISDIRECTED_REQUEST,
  HTTP_EXPECTATION_FAILED,
  HTTP_UNSUPPORTED_MEDIA_TYPE,
  HTTP_URI_TOO_LONG,
  HTTP_REQUEST_TIMEOUT,
  HTTP_PROXY_AUTH_REQUIRED,
  HTTP_METHOD_NOT_ALLOWED,
  HTTP_NOT_FOUND,
  HTTP_UNAUTHORIZED,
]);
export const rejected = "rejected";
export const CODE = 0xfffffff;
export const MIN_INDEX = -1;
export const NO_TO_ADD = 2;
export const DEFAULT_INTERVAL = 10000;

export enum currentlyViewed {
  existing = "existing",
  new = "new",
}

export enum formsType {
  all = "all",
}

export const ProcessFormResult = {
  Success: "Success",
  UnexpectedError: "UnexpectedError",
  ProfileIdNotFound: "ProfileIdNotFound",
} as const;

export type ProcessFormResult =
  (typeof ProcessFormResult)[keyof typeof ProcessFormResult];

export enum AmlCategoryForSanctions {
  enforcement = "enforcement",
  insolvencyRegister = "insolvencyRegister",
  pepCurrent = "pepCurrent",
  pepFormer = "pepFormer",
  pepLinked = "pepLinked",
  profileOfInterest = "profileOfInterest",
  adverseMedia = "adverseMedia",
  disqualifiedDirector = "disqualifiedDirector",
  stateOwnedEnterpriseCurrent = "stateOwnedEnterpriseCurrent",
  stateOwnedEnterpriseFormer = "stateOwnedEnterpriseFormer",
  sanctionsCurrent = "sanctionsCurrent",
  sanctionsFormer = "sanctionsFormer",
}
export const amlCategoriesToDatasetMapping: Record<
  AmlCategoryForSanctions,
  string | string[]
> = {
  // Business categories
  [AmlCategoryForSanctions.sanctionsCurrent]: "SAN-CURRENT",
  [AmlCategoryForSanctions.sanctionsFormer]: "SAN-FORMER",
  [AmlCategoryForSanctions.adverseMedia]: ["ADV-MEDIA", "AM"],
  [AmlCategoryForSanctions.enforcement]: ["ENFORCEMENT", "ENF"],
  [AmlCategoryForSanctions.insolvencyRegister]: ["INSOLVENCY-REGISTER", "INS"],
  [AmlCategoryForSanctions.stateOwnedEnterpriseCurrent]: "SOE-CURRENT",
  [AmlCategoryForSanctions.stateOwnedEnterpriseFormer]: "SOE-FORMER",
  [AmlCategoryForSanctions.disqualifiedDirector]: [
    "DISQUALIFIED-DIRECTOR",
    "DD",
  ],
  // Individual categories
  [AmlCategoryForSanctions.pepCurrent]: "PEP-CURRENT",
  [AmlCategoryForSanctions.pepFormer]: "PEP-FORMER",
  [AmlCategoryForSanctions.pepLinked]: "PEP-LINKED",
  [AmlCategoryForSanctions.profileOfInterest]: ["PROFILE-OF-INTEREST", "POI"],
};

export const businessCategoriesForSanctions = [
  AmlCategoryForSanctions.sanctionsCurrent,
  AmlCategoryForSanctions.sanctionsFormer,
  AmlCategoryForSanctions.enforcement,
  AmlCategoryForSanctions.insolvencyRegister,
  AmlCategoryForSanctions.stateOwnedEnterpriseCurrent,
  AmlCategoryForSanctions.stateOwnedEnterpriseFormer,
  AmlCategoryForSanctions.pepLinked,
  AmlCategoryForSanctions.profileOfInterest,
  AmlCategoryForSanctions.adverseMedia,
];

export const individualCategoriesForSanctions = [
  AmlCategoryForSanctions.sanctionsCurrent,
  AmlCategoryForSanctions.sanctionsFormer,
  AmlCategoryForSanctions.enforcement,
  AmlCategoryForSanctions.insolvencyRegister,
  AmlCategoryForSanctions.disqualifiedDirector,
  AmlCategoryForSanctions.pepCurrent,
  AmlCategoryForSanctions.pepFormer,
  AmlCategoryForSanctions.pepLinked,
  AmlCategoryForSanctions.profileOfInterest,
  AmlCategoryForSanctions.adverseMedia,
];

export enum AmlChangeType {
  Added = "Added",
  Updated = "Updated",
  Deleted = "Deleted",
}
